export default "<markdown src=\"{{'changelog.asset' | translate}}\" ngPreserveWhitespaces>\n</markdown>\n"